module.exports = __webpack_public_path__ + "assets/img/2021-midAutumn-btn3.2a68cbce.png";